let scriptPromise;

export function loadRecaptcha() {
  if (window.grecaptcha?.render) return Promise.resolve(window.grecaptcha);
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve, reject) => {
    const cb = "__recaptchaOnload";
    window[cb] = () => resolve(window.grecaptcha);
    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?onload=${cb}&render=explicit&hl=es`;
    script.async = true;
    script.defer = true;
    script.onerror = () => { scriptPromise = undefined; reject(new Error("No se pudo cargar reCAPTCHA")); };
    document.head.appendChild(script);
  });
  return scriptPromise;
}
